export default "__VITE_ASSET__a3a5f9bf__"